import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-preloader',
  templateUrl: './dialog-preloader.component.html',
  styleUrls: ['./dialog-preloader.component.css']
})
export class DialogPreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
